import { useQuery } from '@tanstack/react-query';
import { turnsGetIssues } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useTurnIssues = (args: { id: number; expand?: string[] }) =>
  useQuery({
    queryFn: () =>
      extractData(
        turnsGetIssues({
          path: { id: args.id },
          query: { expand: args.expand },
        })
      ),
    queryKey: ['turns', args.id, 'issues', args.expand],
  });
